export default "__VITE_ASSET__Z7W3QAE___"